import { useEffect, useState } from 'react';
import type { createApiClient } from '@deloitte-us-consulting/gp-sdk';

type Api = ReturnType<typeof createApiClient>;

/** The active-alliance list (GET /rbac/alliance-catalog) as Select/Multiselect
 *  options — sourced from the sync's own Master-view source of truth, so a
 *  name picked here is guaranteed to be one the sync itself would recognize.
 *  Shared between the admin manual-assignment picker and the self-service
 *  access-request form; the endpoint is open to any authenticated user. */
export function useActiveAllianceOptions(api: Api): { value: string; label: string }[] {
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);
  useEffect(() => {
    api
      .get<{ names: string[] }>('/api/rbac/alliance-catalog')
      .then((r) => setOptions(r.names.map((name) => ({ value: name, label: name }))))
      .catch(() => setOptions([]));
  }, [api]);
  return options;
}
